
import { usRegions } from '../../../mocks/usStates';

interface RegionFilterProps {
  activeRegion: string;
  onRegionChange: (region: string) => void;
  counts: Record<string, number>;
}

const RegionFilter = ({ activeRegion, onRegionChange, counts }: RegionFilterProps) => {
  return (
    <div className="flex flex-wrap gap-2">
      {usRegions.map((region) => {
        const count = region === 'All' ? Object.values(counts).reduce((a, b) => a + b, 0) : (counts[region] || 0);
        return (
          <button
            key={region}
            onClick={() => onRegionChange(region)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              activeRegion === region
                ? 'bg-gray-900 text-white shadow-sm'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {region}
            <span className={`ml-1.5 text-xs ${activeRegion === region ? 'text-gray-300' : 'text-gray-400'}`}>
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default RegionFilter;
